"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calendarPrefsStyles = exports.transactionLabelStyles = exports.daysGridStyles = exports.dayStyles = exports.weekDaysHeaderStyles = exports.headerStyles = void 0;
const daysPerRow = 7;
const headerStyles = (theme) => ({
    monthHeader: {
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        paddingTop: 8,
        paddingBottom: 8,
        paddingLeft: 10,
        borderBottom: `1px solid ${theme.palette.border.subtle}`,
    },
    controlGroup: {
        display: 'flex',
    },
    controlRoot: {},
    iconControl: {
        width: 30,
        height: '100%',
        color: theme.palette.text.secondary,
    },
    iconControlDisabled: {
        color: `${theme.palette.text.disabled} !important`,
    },
    iconToday: {
        transform: 'rotate(45deg)',
        fontSize: '1rem',
        color: theme.palette.icon.secondary,
    },
    settingsRoot: {
        position: 'absolute',
        top: '50%',
        right: 20,
        transform: 'translateY(-50%)',
    },
    settingsIconRoot: {
        padding: 12,
        borderRadius: '50%',
    },
    settingsIcon: {
        width: 20,
        height: 20,
        color: theme.palette.action.active,
    },
    cardHeaderNotClickable: {
        extend: 'cardHeader',
        cursor: 'default',
        padding: 0,
        paddingLeft: 10,
    },
    actions: {
        alignSelf: 'center',
        marginTop: 0,
    },
    title: {
        textTransform: 'uppercase',
    },
});
exports.headerStyles = headerStyles;
const weekDaysHeaderStyles = ({ spacing, palette, typography }) => ({
    weekDays: Object.assign(Object.assign({}, typography.subtitle2), { display: 'flex', background: palette.surface.subtle2, border: `solid 1px ${palette.border.subtle}`, borderLeft: 'none' }),
    dayLabel: {
        flex: `1 0 ${100 / daysPerRow}%`,
        maxWidth: `calc(100% / ${daysPerRow})`,
        textIndent: spacing(1),
        borderLeft: `solid 1px ${palette.border.subtle}`,
        padding: '5px 0',
    },
});
exports.weekDaysHeaderStyles = weekDaysHeaderStyles;
const dayStyles = ({ palette, typography }) => ({
    day: {
        position: 'relative',
        flex: `1 0 ${100 / daysPerRow}%`,
        maxWidth: `calc(100% / ${daysPerRow})`,
        borderLeft: `solid 1px ${palette.border.subtle}`,
        borderBottom: `solid 1px ${palette.border.subtle}`,
        cursor: 'pointer',
        '&.small': {
            height: 30,
            minHeight: 30,
        },
        '&.big': {
            height: 35,
            minHeight: 35,
        },
    },
    notCurrentMonth: {
        background: palette.surface.subtle2,
    },
    header: {},
    dayIndicator: Object.assign(Object.assign({}, typography.subtitle2), { lineHeight: '16px', padding: 0 }),
    currentDay: {
        background: palette.state.selected.strong,
        border: `solid 1px ${palette.border.subtle}`,
        color: palette.text.primary,
    },
    txnWrapper: {
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
    },
});
exports.dayStyles = dayStyles;
const daysGridStyles = ({ palette }) => ({
    days: {
        background: palette.background.paper,
        display: 'flex',
        flexWrap: 'wrap',
        borderRight: `solid 1px ${palette.border.subtle}`,
        marginBottom: 4,
        transform: 'translateZ(0)',
        position: 'relative',
    },
});
exports.daysGridStyles = daysGridStyles;
const transactionLabelStyles = ({ palette }, _props, classes) => ({
    // type styles
    moreType: {
        background: 'none',
        '&:hover': {
            background: 'none',
        },
    },
    incomeType: {
        background: palette.reports.incomeColor,
        '&:hover': {
            background: palette.reports.incomeColor,
        },
    },
    expenseType: {
        background: palette.status.attentionMain,
        '&:hover': {
            background: palette.status.attentionMain,
        },
    },
    overdueType: {
        background: `${palette.other.overdueTxn} !important`,
        '&:hover': {
            background: palette.other.overdueTxn,
        },
    },
    normalType: {
        background: palette.text.tertiary,
        '&:hover': {
            background: palette.text.tertiary,
        },
    },
    dueType: {
        [`& .${classes.reminderIcon}`]: {
            display: 'inline-block',
            color: palette.text.tertiary,
            opacity: 0.90,
        },
    },
    label: {
        height: 6,
        width: 6,
        borderRadius: '50%',
        display: 'inline-block',
        margin: '0px 1px 0px 1px',
    },
});
exports.transactionLabelStyles = transactionLabelStyles;
const calendarPrefsStyles = ({ typography }) => ({
    dialogPaper: {
        overflowY: 'visible',
    },
    buttonArea: {
        padding: 10,
        paddingTop: 0,
        display: 'flex',
        justifyContent: 'space-between',
    },
    fieldRoot: {
        display: 'flex',
        minWidth: 450,
    },
    fieldLabel: Object.assign(Object.assign({}, typography.body2), { flexGrow: 2, marginTop: 'auto', marginBottom: 'auto' }),
});
exports.calendarPrefsStyles = calendarPrefsStyles;
